import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cn from "clsx";
import { useTranslation } from "@crehana/i18n";
import { Container } from "@crehana/ui";
import localeEs from "./i18n/localeEs";
import localePt from "./i18n/localePt";
import BottomSection from "./sections/BottomSection";
import TopSection from "./sections/TopSection";
import { MAIN_FOOTER_PAGE_KEY } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TRANSLATIONS = {
  es: /*#__PURE__*/_defineProperty({}, MAIN_FOOTER_PAGE_KEY, localeEs.es),
  pt: /*#__PURE__*/_defineProperty({}, MAIN_FOOTER_PAGE_KEY, localePt.pt)
};
var MainFooter = function MainFooter(_ref) {
  var isDark = _ref.isDark,
    className = _ref.className,
    _ref$ignoreBgTranspar = _ref.ignoreBgTransparent,
    ignoreBgTransparent = _ref$ignoreBgTranspar === void 0 ? false : _ref$ignoreBgTranspar,
    containerType = _ref.containerType,
    layouts = _ref.layouts;
  var _useTranslation = useTranslation(),
    addResourceBundle = _useTranslation.addResourceBundle;
  addResourceBundle(TRANSLATIONS);
  return /*#__PURE__*/_jsx("footer", {
    id: "main-footer",
    className: cn({
      'bg-base-main-80': isDark,
      'bg-transparent': !isDark && !ignoreBgTransparent
    }, className),
    children: /*#__PURE__*/_jsxs(Container, {
      type: containerType,
      children: [/*#__PURE__*/_jsx(TopSection, {
        isDark: isDark,
        shouldHideWeAreHiringLink: layouts === null || layouts === void 0 ? void 0 : layouts.shouldHideWeAreHiringLink
      }), /*#__PURE__*/_jsx(BottomSection, {
        isDark: isDark
      })]
    })
  });
};
export default MainFooter;